"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.optionsData = void 0;
var optionsData = exports.optionsData = {
  'DD': [{
    'label': '官方',
    'value': 'GF'
  }],
  'DY': [{
    'label': '花卷云',
    'value': 'HJY'
  }, {
    'label': '官方',
    'value': 'GF'
  }, {
    'label': '穿山甲',
    'value': 'CSJ'
  }],
  'ELM': [{
    'label': '官方',
    'value': 'GF'
  }],
  'JD': [{
    'label': '京推推',
    'value': 'JTT'
  }, {
    'label': '官方',
    'value': 'GF'
  }],
  'KS': [{
    'label': '官方',
    'value': 'GF'
  }],
  'MT': [{
    'label': '美团',
    'value': 'MTLM'
  }, {
    'label': '美团千载',
    'value': 'MTQZ'
  }],
  'OT': [{
    'label': '官方',
    'value': 'GF'
  }],
  'PDD': [{
    'label': '官方',
    'value': 'GF'
  }],
  'QF': [{
    'label': '官方',
    'value': 'GF'
  }],
  'TB': [{
    'label': '折淘客',
    'value': 'ZTK'
  }, {
    'label': '大淘客',
    'value': 'DTK'
  }, {
    'label': '好单库',
    'value': 'HDK'
  }, {
    'label': '淘宝工具商',
    'value': 'GFZI'
  }, {
    'label': '官方',
    'value': 'GF'
  }],
  'TXYX': [{
    'label': '官方',
    'value': 'GF'
  }],
  'WPH': [{
    'label': '官方',
    'value': 'GF'
  }]
};